import React from "react";
import classNames from "classnames";

import { FolderIcon } from "@common/folderIcon";
import { ArrowIcon } from "@common/assets/arrowIcon";
import { NameWithCount } from "./nameWithCount";
import { Props } from "./type";
import styles from "./styles.scss";

function Input({ project, placeholder, isOpen }: Props) {
  return (
    <div
      className={classNames(styles.input, {
        [styles.opened]: isOpen,
      })}
    >
      {!project ? (
        <p className={styles.placeholder}>{placeholder}</p>
      ) : (
        !!project && (
          <NameWithCount
            name={project.name}
            icon={<FolderIcon className={styles.folder} />}
          />
        )
      )}

      <ArrowIcon className={styles.toggleIcon} />
    </div>
  );
}

export { Input };
